import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=72a3f544&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a3f544')) {
      api.createRecord('72a3f544', component.options)
    } else {
      api.reload('72a3f544', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=72a3f544&", function () {
      api.rerender('72a3f544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4XF5IVD2DdGb5/JS/comp/pricelist.vue"
export default component.exports